// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCard_card__3UGhS","cardRoot":"EventCard_cardRoot__1qYwD","cardTitle":"EventCard_cardTitle__3PGgf","cardContent":"EventCard_cardContent__3ao9r"};